import PropertyObject from "../../../types/property/PropertyObject";
import { GET_PROPERTIES, RESET_PROPERTIES, UPDATE_PROPERTY } from "../../actionTypes/actionsTypes";
import defaultAsyncReducer from "../../defaultReducer";
import { AppAction, BaseAsyncReducerState, LocalAction } from "../../types";

export interface PropertiesState extends BaseAsyncReducerState {
    found: boolean;
    profiles: PropertyObject[]
}

const initialState: PropertiesState = {
    found: false,
    profiles: [],
    loading: false,
    error: false
}

function getPropertiesReducer(state = initialState, action: AppAction | LocalAction) {
    if (action.type === RESET_PROPERTIES) {
        return { ...initialState };
    } else if (action.type === UPDATE_PROPERTY) {
        const data = (action as LocalAction).data as PropertyObject
        const updatedProfiles = state.profiles.map(profile => {
            if (profile.campaignId === data.campaignId) {
                return { ...profile, ...data }
            } else {
                return profile
            }
        })
        return { ...state, profiles: updatedProfiles }
    } else {
        return defaultAsyncReducer(state, action as AppAction, GET_PROPERTIES);
    }
}

export default getPropertiesReducer;